import axios from 'axios';
import Select2 from 'v-select2-component';

export default {
    components: {
        'select2': Select2
    },
    name: 'SelectCompanyGroup',
    props: {
        value: [Number],
        inputclass: {
            type: String,
            default: ''
        },
        emptyname: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            groups: []
        };
    },
    computed: {
        options() {
            return this.groups.map(x => {
                return { id: x.id, text: x.description };
            });
        },
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            axios.get(APIURL + '/shared/companies/company/groups')
                .then(resp => this.groups = resp.data);
        },
    }
};